import { merge } from 'lodash-es';
import { EnvironmentConfigurationService } from './env.config.service';

export const EnvServiceFactory = () => {
  // Create env
  const env = new EnvironmentConfigurationService();

  // Read environment variables from browser window
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow['appConfig'] || {};

  // Assign environment variables from browser window to env
  // In the current implementation, properties from env.js overwrite defaults from the EnvironmentConfigurationService.
  // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
  for (const key in browserWindowEnv) {
    if (browserWindowEnv.hasOwnProperty(key)) {
      const originalConfigForKey = env[key];
      env[key] = merge(originalConfigForKey, window['appConfig'][key]);
    }
  }
  env.environment.scipVersion = '4.5.0';
  return env;
};

export const EnvConfigServiceProvider = {
  provide: EnvironmentConfigurationService,
  useFactory: EnvServiceFactory,
  deps: []
};
